import { device } from '@/utils/devices-screens';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';

export const Banner = styled.h3`
  font-size: 40px;
  line-height: 55px;
  font-weight: 400;
  color: var(--text-theme);
  margin-bottom: 15px;
`;

export const PaymentCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--text-theme);
  border-top: 1px solid #e1e1e1;
  padding-left: 26px;
  padding-top: 20px;
  margin-top: 16px;
`;

export const CheckoutSectionTitle = styled.h2`
  font-weight: 400;
  margin-bottom: 16px;
  font-size: 16px;
  display: flex;
`;

export const PaymentCardForm = styled.div`
  grid-gap: 16px;
  gap: 16px;
  width: 100%;
  max-width: 820px;
`;

export const PaymentCardRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2,auto);
  grid-gap: 24px;
  gap: 24px;
  margin-top: 20px;
`;

export const CheckoutInput = styled.input<{ error?: boolean }>`
  background-color: #e9e9e9;
  border: 2px solid ${props => props.error ? 'var(--red2)' : '#e9e9e9'};
  padding: 15px 16px;
  border-radius: 8px;
  display: inline-flex;
  color: var(--text-theme);
  width: 100%;
  min-width: 100%;
  font-size: 18px;

  + span {
    color: var(--red2);
    font-size: 14px;

  }
`;

export const PaymentCardList = styled.ul`
  display: flex;
  margin-bottom: 16px;
`;

export const PaymentCardItem = styled.li`
  margin: 0 8px 0 0;
  width: 45px;
  height: 30px;
  border-radius: 8px;
  overflow: hidden;
`;

export const PaymentCardImg = styled.img`
  object-fit: cover;
  width: 100%;
`;

export const PaymentContainer = styled.div`
  margin-left: 10px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const ProductInfoContainer = styled.div`
  display: flex;
  margin: 0 0 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  @media ${device.tablet} {
    flex-direction: column;
  }
`;

export const ProductImageContainer = styled.div`
  width: 150px;
  height: 150px;
  margin-bottom: 16px;
  margin-top: 16px;
`;

export const ProductImage = styled.img`
  display: block;
  border-radius: 6px;
  width: 100%;
`;

export const ProductDescription = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-theme);
  margin-top: 5px;
  margin-bottom: 15px;
`;

export const ProductPrice = styled.div`
  div {
    display: flex;
  }

  h4:nth-child(1) {
    margin-right: 5px;
  }

  h4:nth-child(2) {
    color: var(--text-theme);
    text-decoration: line-through;
  }
`;

export const Back = styled.a`
  font-size: 14px;
  display: flex;
  text-decoration: none;
  margin-bottom: 20px;
  cursor: pointer;
  span {
    margin-top: 3px;
    margin-right: 5px;
    font-size: 14px;
  }
`;

export const SecurityPayment = styled.div`
  display: flex;
  justify-content: center;
  span {
    margin-right: 5px;
    color: #67bd11;
  }
  
  p {
    text-align: center;
    font-weight: 400;
    margin-bottom: 16px;
    font-size: 16px;
    color: #67bd11;
  }
`
